import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../Theme';

const parseAspectRatio = imageAspect => {
  const [width, height] = String(imageAspect).split(':').map(Number);
  if (!width || !height) return '1 / 1';
  return `${width} / ${height}`;
};

const SkeletonCard = styled('div')`
  width: 100%;

  @keyframes elevateCardShimmer {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: -100% 0;
    }
  }

  .elevate-sk {
    background: linear-gradient(90deg, #ebe8e3 0%, #f6f4f1 40%, #ebe8e3 80%);
    background-size: 200% 100%;
    animation: elevateCardShimmer 1.15s ease-in-out infinite;
    border-radius: 4px;
  }

  .elevate-sk-image-wrap {
    position: relative;
    width: 100%;

    &:before {
      content: '';
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.03);
      pointer-events: none;
      z-index: 1;
    }
  }

  .elevate-sk-image {
    width: 100%;
    aspect-ratio: ${props => props.imageAspectRatio};
    border-radius: 2px;
  }

  .elevate-sk-fav {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    z-index: 2;
  }

  .elevate-product-card-content {
    padding-top: 14px;

    ${theme.below.lg} {
      padding-top: 10px;
    }
  }

  .elevate-product-card-rating-and-availability {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    min-height: 20px;
    margin-bottom: 0;

    ${theme.below.md} {
      flex-direction: column-reverse;
      align-items: flex-start;
      justify-content: flex-start;
      margin-bottom: 6px;
    }
  }

  .elevate-sk-rating {
    width: 72px;
    height: 20px;
  }

  .elevate-sk-availability {
    width: 56px;
    height: 12px;
    margin-top: 6px;

    ${theme.below.md} {
      margin-top: 0;
      margin-bottom: 4px;
    }
  }

  .elevate-sk-brand {
    width: 42%;
    height: 13px;
    margin-top: 13px;
    margin-bottom: 2px;
    border-radius: 2px;
  }

  .elevate-sk-title {
    /* min-height: calc(11px + 2 * 1.2 * 14px); */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 2px;
    /* margin-bottom: 8px; */
  }

  .elevate-sk-title-line {
    height: 14px;
    width: 87%;
    border-radius: 2px;
  }

  .elevate-sk-title-line--short {
    width: 68%;
  }

  .elevate-sk-title-line--shorter {
    width: 52%;
  }

  .elevate-sk-price {
    width: 45%;
    height: 34px;
    margin-top: 5px;

    ${theme.below.md} {
      height: 2rem;
    }

    @media screen and (max-width: 430px) {
      height: 1.4rem;
    }
  }

  .elevate-sk-variants {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 5px;
    margin-top: 29px;
  }

  .elevate-sk-variant {
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }
`;

export const ElevateSkeletonProductCard = ({
  as = 'li',
  imageAspect = '1:1',
  showVariants = true
}) => {
  const Wrapper = as;

  return (
    <Wrapper className="elevate-product-card elevate-skeleton-product-card">
      <SkeletonCard
        className="elevate-skeleton-product-card-inner"
        imageAspectRatio={parseAspectRatio(imageAspect)}
        aria-hidden="true"
      >
        <div className="elevate-sk-image-wrap">
          {/* <div className="elevate-sk elevate-sk-fav" /> */}
          <div className="elevate-sk elevate-sk-image" />
        </div>

        <div className="elevate-product-card-content">
          <div className="elevate-product-card-rating-and-availability">
            <div className="elevate-sk elevate-sk-rating" />
            <div className="elevate-sk elevate-sk-availability" />
          </div>

          <header style={{ flexDirection: 'column' }}>
            <div className="elevate-sk elevate-sk-brand" />
            <div className="elevate-sk-title">
              <div className="elevate-sk elevate-sk-title-line" />
              <div className="elevate-sk elevate-sk-title-line elevate-sk-title-line--short" />
              {/* <div className="elevate-sk elevate-sk-title-line elevate-sk-title-line--shorter" /> */}
            </div>
          </header>

          <div className="elevate-sk elevate-sk-price" />
        </div>

        {showVariants && (
          <div className="elevate-sk-variants">
            {Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="elevate-sk elevate-sk-variant" />
            ))}
          </div>
        )}
      </SkeletonCard>
    </Wrapper>
  );
};
